import { Injectable } from '@angular/core';
import { Description } from '../../models/Description';
import { TypeObjCPV } from '../../models/TypeObjCPV';
import { TypeCPVClass } from '../../models/TypeCPVClass';
import { TypeLieu } from '../../models/TypeLieu';
import { TypeVoie } from '../../models/TypeVoie';
import { TypeFournitures } from '../../models/TypeFournitures';
import { TypeTravaux } from '../../models/TypeTravaux';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
import { ChampsLibresTexte } from '../../models/ChampsLibresTexte';

@Injectable({
  providedIn: 'root'
})
export class DescriptionService {

  constructor() {
  }

  public getDescription(controls, formExtractorService): Description {

    const objetComplementaire_iters = formExtractorService.getIndexes(Array.from(controls.keys()), ['Description', 'TypeObjCPV'], '_SepSep_TypeObjCPV_index_');

    let objetComplementaire_iter = 0;

    const description = new Description();
    description.objet.txtLibre = {champsLibre: []};

    description.marcheServices = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepAtt_marcheServices'));
    description.objet = new ChampsLibresTexte();
    const PLACEHOLDER = '\u200B\u200B\u200B\u200B\u200B';
    const tempChampsLibre = [PLACEHOLDER, PLACEHOLDER];
    const champ0 = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_ChampsLibresTexte_SepSep_ChampLibreGroup_SepAtt_champsLibre');
    if (champ0?.trim() && champ0.length >= 5) {
      tempChampsLibre[0] = champ0;
    }
    const champ1 = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepAtt_champsLibre');
    if (champ1?.trim() && champ1.length >= 5) {
      tempChampsLibre[1] = champ1;
    }
    description.objet.txtLibre.champsLibre = tempChampsLibre;
    description.objet.intLibre.intituleLibre = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_ChampsLibresTexte_SepSep_IntituleLibreGroup_SepAtt_intituleLibre'));
    description.objet.intLibre.intituleLibreLibelle = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_ChampsLibresTexte_SepSep_IntituleLibreGroup_SepAtt_intituleLibreLibelle'));
    description.descriptionMarche.cpv = new TypeObjCPV();


    objetComplementaire_iters.forEach(() => {
      description.descriptionMarche.cpv.objetComplementaire[objetComplementaire_iter] = new TypeCPVClass();
      description.descriptionMarche.cpv.objetComplementaire[objetComplementaire_iter].classSupplementaire = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
      description.descriptionMarche.cpv.objetComplementaire[objetComplementaire_iter].classPrincipale = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeObjCPV_index_' + (objetComplementaire_iter + 1) + '_SepSep_TypeCPVClass_SepAtt_classPrincipale');

      objetComplementaire_iter++;
    });

    description.descriptionMarche.cpv.objetPrincipal = new TypeCPVClass();
    description.descriptionMarche.cpv.objetPrincipal.classSupplementaire = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classSupplementaire');
    description.descriptionMarche.cpv.objetPrincipal.classPrincipale = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale'));


    switch (controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepAtt_travaux')) {
      case RadioCheckBoxEnum.travauxValue:
        description.descriptionMarche.natureMarche.travaux = '';
        description.descriptionMarche.natureMarche.services = null;
        description.descriptionMarche.natureMarche.fournitures = null;
        break;
      case RadioCheckBoxEnum.servicesValue:
        description.descriptionMarche.natureMarche.travaux = null;
        description.descriptionMarche.natureMarche.services = '';
        description.descriptionMarche.natureMarche.fournitures = null;
        break;
      case RadioCheckBoxEnum.fournituresValue:
        description.descriptionMarche.natureMarche.travaux = null;
        description.descriptionMarche.natureMarche.services = null;
        description.descriptionMarche.natureMarche.fournitures = '';
        break;
    }

    description.cpv = null;


    const lieuExecutionLivraison = controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepAtt_lieuExecutionCB');

    if (lieuExecutionLivraison) {
      description.lieuLivraison = null;
      description.lieuExecution = null;

      description.lieuExecutionLivraison = new TypeLieu();
      description.lieuExecutionLivraison.ville = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_ville'));
      description.lieuExecutionLivraison.cp = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_cp'));

      description.lieuExecutionLivraison.voie = new TypeVoie();
      description.lieuExecutionLivraison.voie.typevoie = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie'));
      description.lieuExecutionLivraison.voie.nomvoie = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie'));
      description.lieuExecutionLivraison.voie.num = this.sanitizeString(controls.get('lieuExecutionLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num'));
    } else {
      description.lieuExecutionLivraison = null;

      description.lieuLivraison = new TypeLieu();
      description.lieuLivraison.ville = this.sanitizeString(controls.get('lieuLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_ville'));
      description.lieuLivraison.cp = this.sanitizeString(controls.get('lieuLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_cp'));

      description.lieuLivraison.voie = new TypeVoie();
      description.lieuLivraison.voie.typevoie = this.sanitizeString(controls.get('lieuLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie'));
      description.lieuLivraison.voie.num = this.sanitizeString(controls.get('lieuLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num'));
      description.lieuLivraison.voie.nomvoie = this.sanitizeString(controls.get('lieuLivraison_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie'));

      description.lieuExecution = new TypeLieu();
      description.lieuExecution.ville = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_ville'));
      description.lieuExecution.cp = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepAtt_cp'));

      description.lieuExecution.voie = new TypeVoie();
      description.lieuExecution.voie.num = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_num'));
      description.lieuExecution.voie.typevoie = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_typevoie'));
      description.lieuExecution.voie.nomvoie = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeLieu_SepSep_TypeVoie_SepAtt_nomvoie'));
    }
    description.isLieuExecutionLivraison = lieuExecutionLivraison;

    description.marcheFournitures = new TypeFournitures();
    description.marcheFournitures.achat = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeFournitures_SepAtt_achat'));
    description.marcheFournitures.creditBail = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeFournitures_SepAtt_creditBail'));
    description.marcheFournitures.location = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeFournitures_SepAtt_location'));
    description.marcheFournitures.locationVente = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeFournitures_SepAtt_locationVente'));
    description.marcheServices = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepAtt_marcheServices'));
    description.marcheTravaux = new TypeTravaux();
    description.marcheTravaux.conceptionRealisation = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeTravaux_SepAtt_conceptionRealisation'));
    description.marcheTravaux.execution = this.sanitizeString(controls.get('_SepSep_TypeAnn_DIVER_G1_SepSep_Description_SepSep_TypeTravaux_SepAtt_execution'));

    return description;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
